/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *           _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Injectable } from '@angular/core';

/**
 * An awesome tiny JavaScript library that can be used to detect WebRTC features e.g. system having speakers, microphone
 * or webcam, screen capturing is supported, number of audio/video devices etc.
 */
import DetectRTC from 'detectrtc';

/**
 * Audio Capture helper service to determine audio compatibility in browsers / devices.
 * Could be used for many other utility methods.
 *
 * ( Might even be able to replace our current browser service ).
 */
@Injectable()
export class AudioCompatibilityService {
  /**
   * Default Constructor.
   */
  constructor() {}

  /**
   * Method to determine whether or not the Browser / Device supports WebRTC.
   *
   * @returns boolean
   */
  isWebRTCSupported() : boolean {
    return DetectRTC.isWebRTCSupported;
  }

  /**
   * Method to determine whether or not the user is using a mobile device.
   * @returns boolean
   */
  isMobileDevice() : boolean {
    return DetectRTC.isMobileDevice;
  }

  /**
   * Method to determine whether or not the user is using the chrome browser.
   *
   * @returns boolean
   */
  isChromeBrowser() : boolean {
    return DetectRTC.browser.isChrome;
  }

  /**
   * Method to determine whether or not the user is using the MS ***Legacy*** Edge browser.
   *
   * @returns boolean
   */
  isLegacyEdgeyBrowser() : boolean {
    return DetectRTC.browser.isEdge;
  }

  /**
   * Method to determine whether or not the user is using the Safari browser.
   *
   * @returns boolean
   */
  isSafariBrowser() : boolean {
    return DetectRTC.browser.isSafari;
  }

  /**
   * Return browser details.
   */
  browserDetails() : any {
    return DetectRTC.browser;
  }

  /**
   * Return OS name for device.
   */
  osName() : string {
    return DetectRTC.osName;
  }
}
